<div id="loadingBox" *ngIf="!initCompleted">
  <img src="assets/images/bus2.gif" />
  <div>Laddar BKS</div>
</div>

<div *ngIf="requireMenu" [hidden]="!initCompleted" class='col-sm-12' style="position:sticky;overflow:visible;z-index:100;top:0px;padding-left:0;padding-right:0">
  <app-nav-bar></app-nav-bar>
</div>
<div *ngIf="initCompleted">
  <router-outlet></router-outlet>
</div>
